import { useContext } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { ArrowBackIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import InventoryDetailContext from '../InventoryDetailContext';

import classes from './header.module.css';

const NavigationTitle = () => {
  const { asset } = useContext(InventoryDetailContext);
  const [, { backDestination, navigate }] = useNavigation();

  const navigateBack = () => navigate(backDestination('/inventory'));

  return (
    <div>
      <IconButton
        tooltip="Back"
        onClick={navigateBack}
        data-cy="inventoryDetailBackButton"
      >
        <Icon color={colors.neutral.white} icon={ArrowBackIcon} />
      </IconButton>
      <div className={classes.titleBar}>
        <span>{asset.name}</span>
      </div>
    </div>
  );
};

export default NavigationTitle;
